import React, { useRef } from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
import CxHidden from '../../cx/CxHidden';
import CxInput from '../../cx/CxInput';
import CxDate from '../../cx/CxDate';
import CxChooser from '../../cx/CxChooser';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import { StoreClient } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import CxSnackbar from '../../cx/CxSnackbar';
import { useAccess } from '../../hx/useAccess';
import CxStatic from '../../cx/CxStatic';


const MxClientJournalForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ isFullAccess }] = useAccess(trans('field.clients'));

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);

  const [storeClient, setStoreClient] = useSessionStorage('StoreClient', StoreClient);

  let r_form = React.useRef(null);

  const r_snack_ask_save = React.useRef(null);

  const rf_date = React.useRef(null);
  const rf_txTypeStatusClientJournal = React.useRef(null);


  React.useEffect(() => {
    // eslint-disable-next-line
  }, []);

  const formLoad = async (data) => {
    if (data===null) { //nuevo registro
      rf_date.current.setValToday();
      rf_txTypeStatusClientJournal.current.setKeyAndVal("t_status_client_journal", "txTypeStatusClientJournal", "itStatusClientJournal", "000001.SRV");
      
    }
  }
  const formSave = async (lastSaveRv) => {
    if (lastSaveRv.theValue.startsWith("rv_")) {
      // errores al guardar
    } else {
      // se guardó exitosamente
      storeClient.inClientJournal = lastSaveRv.theValue;
      Promise.all([setStoreClient(storeClient)]).then((result) => {
        forceUIUpdate();
      });
    }

  }
  const formDelete = async (rv) => {
  }

  return (
    <div>
      <GxForm 
        moduleName={`${trans('field.client')}: ${trans('field.journal')}`}
        xref={r_form}
        url="clients/journal" 
        filterIdField='inClientJournal' 
        filterIdValue={storeClient.inClientJournal} 
        onFormLoad={formLoad} 
        onFormSave={isFullAccess() && formSave} 
        onFormDelete={isFullAccess() && formDelete} 
        >
        <CxHidden xref={useRef(null)} dbfield="n_client_journal.inClient" value={storeClient.inClient || ''} />

        <CxStatic label={`${storeClient.txClient}`} border='none' fontcolor='var(--ibs_color_blue)' fontsize='12px' />

        <CxDate xref={rf_date} label={trans('field.date')} dbfield="n_client_journal.dtClientJournal" required/>
        
        <CxChooser xref={rf_txTypeStatusClientJournal}
          label={trans('field.status')}
          dbfield="t_status_client_journal.txTypeStatusClientJournal" dbfieldkey="n_client_journal.itStatusClientJournal"
          table="t_status_client_journal"
          col_id="itStatusClientJournal"
          col_tx="txTypeStatusClientJournal"
          required
        />

        <CxInput xref={useRef(null)} label={trans('field.journal')} dbfield="n_client_journal.txClientJournal" maxLength={50} speech required />
        <CxInput xref={useRef(null)} label={trans('field.remarks')} dbfield="n_client_journal.txRemarks" minRows={2} speech />
        
      </GxForm>

      <CxSnackbar xref={r_snack_ask_save} severity="error" value={trans('msg.save_before')} />
      
    </div>
  );

}

export default MxClientJournalForm;
